import React from 'react';

export const generateOverviewFormConfig = ({ TermAndConditions, StopperMessage, trackApplicationReasonChange }) => [
  {
    component: 'Checkbox',
    name: 'consentGiven',
    label: '',
    testId: 'consent-given',
    children: <TermAndConditions />,
    validate: value =>
      value === false ? 'To proceed, check the box to confirm that you agree to the terms above' : null,
  },
];
